import ModalMixins from '@/mixins/ModalMixins/index.js'
export default function() {
    return {
        mixins: [ModalMixins],
        props:[],
        methods: {}
    };
};
